import { ACTIONS } from "../actions/team-schedule";

const headerTable = ['試合日', '開始時間/スコア', '球場', '勝利投手', 'セーブ投手', '敗戦投手', '観衆'];
export default (state = {
    headerTable
}, action) => {
    switch (action.type) {
        case ACTIONS.GET_INFO_TEAM_SCHEDULE_SUCCESS:
            return {
                ...state,
                status: action.type,
                response: action.data.data,
            };
        case ACTIONS.GET_INFO_TEAM_SCHEDULE_ERROR:
            return {
                ...state,
                status: action.type,
                response: action.err,
            }
        default:
            return state;
    }
};